import React, { createRef, createContext } from 'react'
import { object, any, func, string } from 'prop-types'
import FaAngleDown from 'react-icons/lib/fa/angle-down'
import FaEye from 'react-icons/lib/fa/eye'

import CircuitPopup from '../CircuitPopup/CircuitPopup'
import styles from './WeekWorkoutSummary.styl'
import { withContext } from '../../../utils/withContext'

class WeekWorkoutSummary extends React.Component {


	static propTypes = {
		workout: object,
		context: object,
		isExpanded: any,
		onClick: func
	}

	static contextType = React.createContext()

	constructor(props) {
		super(props)
		this.itemRef = createRef()
		this.state = { exerciseDisplay: { state: false } }
	}

	parseTime(workout) {
		if (workout.serie && (workout.goal || {}).name === 'PA') {
			return `${ workout.serie.repetitions } x (${ workout.serie.accelerationTime } + ${ workout.serie.time } + ${ workout.serie.recoveryTime })`
		}
		return (workout.currentParams || {}).time || ''
	}
	renderWorkout(workout) {
		const { context: { i18n } } = this.props
		if (!workout) {
			return null
		}
		return [
			this.renderBlock(i18n`slope_label`, (workout.slope || {}).name || '', ''),
			this.renderBlock(i18n`distance_label`, (workout.currentParams || {}).distance || '', 'km', (workout.athleteParams || {}).distance || ''),
			this.renderBlock(i18n`time_label`, this.parseTime(workout), 'min', (workout.athleteParams || {}).time || ''),
			this.renderBlock(i18n`average_bpm_label`, (workout.currentParams || {}).averageBPM || '', 'ppm', (workout.athleteParams || {}).averageBPM || ''),
			this.renderCircuit(workout)

		]
	}

	renderCircuit(workout) {
		const { context: { i18n } } = this.props
		return [
			<tr key="weight">
				<td><strong>{ i18n`weight_label` }</strong></td>
				<td className={ styles['circuit-row'] }>
					{ workout.weightWorkout ? `${ workout.weightWorkoutInfo.reps } x ${ workout.weightWorkout.name }` : '--' }
					<FaEye
						color={ workout.weightWorkout ? '#eb6800' : '#e3e3e3' }
						height="20px"
						width="20px"
						onClick={ (e) => {
							e.stopPropagation()
							if (!workout.weightWorkout) { return }
							this.setState({ exerciseDisplay: { state: true, exercises: workout.weightWorkout.exercises, percentage: workout.weightWorkoutInfo.percentage } })
						} }
					/>

				</td>
			</tr>,
			<tr key="flex">
				<td><strong>{ i18n`flexibility_label` }</strong></td>
				<td className={ styles['circuit-row'] }>
					{ workout.flexWorkout ? `${ workout.flexWorkoutInfo.reps } x ${ workout.flexWorkout.name }` : '--' }
					<FaEye
						color={ workout.flexWorkout ? '#eb6800' : '#e3e3e3' }
						height="20px"
						width="20px"
						onClick={ (e) => {
							e.stopPropagation()
							if (!workout.flexWorkout) { return }
							this.setState({ exerciseDisplay: { state: true, exercises: workout.flexWorkout.exercises, percentage: workout.flexWorkoutInfo.percentage } })
						} }
					/>

				</td>
			</tr>
		]
	}

	renderBlock(title, value, unit, done) {
		return (
			<tr>
				<td><h4>{ title }</h4></td>
				<td className={ styles['value-cell'] }>{ value } { done ? <span>/ { done }</span> : '' } { unit }</td>
			</tr>
		)
	}

	render() {
		const { workout, isExpanded, onClick } = this.props
		const { exerciseDisplay } = this.state
		return (
			<li
				className={ `${ styles['list-item'] } ${ styles[workout['enabled'] ? 'active' : 'inactive'] } ${ styles[isExpanded && workout['enabled'] ? 'expanded' : 'closed'] }` }
			>
				{ exerciseDisplay.state ? <CircuitPopup exercises={ exerciseDisplay.exercises } percentage={ exerciseDisplay.percentage } close={ () => { this.setState({ exerciseDisplay: { state: false } }) } } /> : null }
				<div onClick={ onClick }>
					<div className={ styles['title-container'] }>
						<div className={ `${ styles['down-arrow'] } ${ isExpanded ? styles['rotate'] : '' }` }><FaAngleDown /></div>
						<h3>{ workout['title'] }{ workout['secondary'] ? <span>2</span> : null }</h3>{ workout['enabled'] ? <small>{ workout.sport || '' } :: { (workout.goal || {}).name || '' } :: { this.parseTime(workout) }min</small> : null }
					</div>
					<div
						className={ styles['workout-container'] }
						style={ isExpanded && workout['enabled'] ? { maxHeight: this.itemRef.current ? getComputedStyle(this.itemRef.current).height : 'auto' } : {} }
					>
						<div ref={ this.itemRef }>
							<table className={ styles['table-container'] }>
								<tbody>
									{ this.renderWorkout(workout) }
								</tbody>
							</table>
							{ workout['secondary'] ?
								<div className={ styles['secondary-workout-container'] }>
									<span>2</span>
									{ workout['enabled'] ? <small>{ workout['secondary'].sport || '' } :: { (workout['secondary'].goal || {}).name || '' } :: { this.parseTime(workout['secondary']) }min</small> : null }
									<table className={ styles['table-container'] }>
										<tbody>
											{ this.renderWorkout(workout['secondary']) }
										</tbody>
									</table>
								</div> : null }
						</div>
					</div>
				</div>
			</li >
		)
	}
}

export default withContext(WeekWorkoutSummary)



// WEBPACK FOOTER //
// ./src/client/webapp/components/WeekWorkoutSummary/WeekWorkoutSummary.js